import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { capitalize } from 'lodash-es';
import { matchSorter } from 'match-sorter';
import { Autocomplete, Tooltip, Typography } from 'seagull';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { hasSalesAccount } from '~/models/accounting-integration';
import { Accounting } from '~/types/api.model';
import { getAccountingDetails } from '../accounting.utils';
import styles from './ServiceAccountingAutocomplete.module.scss';
const ServiceAccountingAutocomplete = (param)=>{
    let { accountingItems, selectedOption, isDisabled, hasError, onItemChange: onAccountingItemChange, testId, showAccountingMapPlaceHolder, accounting } = param;
    const isLoading = !accountingItems;
    const { fullName, items, name } = getAccountingDetails(accounting);
    const { SERVICE_TEMPLATE_BUNDLE } = useFeatureFlags();
    const getOptionDisabled = (option)=>{
        if (accounting === Accounting.Xero && !hasSalesAccount(option)) return /*#__PURE__*/ _jsxs("div", {
            "data-testid": "".concat(testId, "-tooltip"),
            children: [
                "Item is missing a Sales account in ",
                getAccountingDetails(accounting).name
            ]
        });
        return undefined;
    };
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: isDisabled ? "".concat(fullName, " ").concat(items, " can be mapped through the ").concat(items, " library") : '',
        children: /*#__PURE__*/ _jsx("div", {
            children: /*#__PURE__*/ _jsx(Autocomplete, {
                testId: testId,
                value: selectedOption,
                options: accountingItems || [],
                mobile: {
                    renderAsCard: true
                },
                onChange: (_, newOption)=>onAccountingItemChange(newOption),
                renderOption: (option)=>/*#__PURE__*/ _jsx("div", {
                        className: styles.accountingItemOption,
                        "data-testid": "".concat(testId, "-option-").concat(option.id),
                        children: /*#__PURE__*/ _jsx(Tooltip, {
                            placement: "top",
                            title: getOptionDisabled(option) || '',
                            children: SERVICE_TEMPLATE_BUNDLE ? /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        skin: "primary",
                                        ellipsis: true,
                                        children: option.name
                                    }),
                                    /*#__PURE__*/ _jsx(Typography, {
                                        testId: "option-type-".concat(option.id),
                                        ellipsis: true,
                                        children: capitalize(option.type)
                                    })
                                ]
                            }) : /*#__PURE__*/ _jsx(Typography, {
                                skin: "primary",
                                ellipsis: true,
                                children: option.name
                            })
                        })
                    }),
                getOptionSelected: (option, value)=>option.id == value.id,
                getOptionLabel: (option)=>option.name,
                filterOptions: (options, param)=>{
                    let { inputValue } = param;
                    const filteredItems = matchSorter(options, inputValue, {
                        keys: [
                            'name'
                        ]
                    });
                    return filteredItems;
                },
                getOptionDisabled: (option)=>!!getOptionDisabled(option),
                noOptionsText: "No ".concat(name, " ").concat(items),
                loading: isLoading,
                disabled: isLoading || isDisabled,
                textFieldProps: {
                    bi: {
                        name: "".concat(accounting, "_mapping")
                    },
                    alwaysShrinkLabel: showAccountingMapPlaceHolder,
                    label: "".concat(fullName, " mapping"),
                    placeholder: isLoading ? '' : 'Not mapped',
                    error: hasError
                },
                selectOnFocus: true,
                disableClearable: false,
                multiple: false,
                freeSolo: false
            })
        })
    });
};
export default ServiceAccountingAutocomplete;
